import { useTranslation } from "react-i18next";
import AdminDashboardItem from "../../../types/admin/dashboard/AdminDashboardItem";
import { AdminDashboardSectionConfig } from "./adminDashboardSections";
import AdminDashboardTileGrid from "./AdminDashboardTileGrid";

interface AdminDashboardSectionProps {
  section: AdminDashboardSectionConfig;
  items: AdminDashboardItem[];
}

const AdminDashboardSection = ({
  section,
  items,
}: AdminDashboardSectionProps) => {
  const { t } = useTranslation();

  return (
    <section aria-labelledby={section.headingId}>
      <h2
        id={section.headingId}
        className="coloured-heading !mt-0 !mb-4 !text-xl text-balance"
      >
        {t(section.titleKey, section.defaultTitle)}
      </h2>
      <AdminDashboardTileGrid items={items} headingId={section.headingId} />
    </section>
  );
};

export default AdminDashboardSection;
